// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1vGgL","footer":"ChangeClinic_footer__1aAwr"};